import { render, staticRenderFns } from "./TimeTableSetting.vue?vue&type=template&id=884c1cee&scoped=true"
import script from "./TimeTableSetting.vue?vue&type=script&lang=js"
export * from "./TimeTableSetting.vue?vue&type=script&lang=js"
import style0 from "./TimeTableSetting.vue?vue&type=style&index=0&id=884c1cee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884c1cee",
  null
  
)

export default component.exports